import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommHeartOutlineIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M3.96233 3.13335C7.01273 1.25797 9.74925 2.00539 11.4024 3.24971C11.6744 3.45442 11.861 3.59452 12 3.68913C12.139 3.59452 12.3256 3.45442 12.5976 3.24971C14.2507 2.00539 16.9873 1.25797 20.0377 3.13335C22.1469 4.43012 23.3338 7.13887 22.9173 10.2511C22.4988 13.3784 20.4793 16.9154 16.2023 20.0883C16.1665 20.1148 16.1311 20.1412 16.0959 20.1673C14.6107 21.2698 13.6271 21.9999 12 21.9999C10.3729 21.9999 9.38932 21.2698 7.90413 20.1673C7.86894 20.1412 7.83346 20.1148 7.79768 20.0883C3.52072 16.9154 1.50116 13.3784 1.08269 10.2511C0.666226 7.13887 1.85307 4.43012 3.96233 3.13335ZM11.8396 3.78825C11.8363 3.78974 11.8369 3.78925 11.841 3.78759C11.8405 3.78784 11.84 3.78806 11.8396 3.78825ZM12.159 3.78759C12.1631 3.78925 12.1637 3.78974 12.1604 3.78825C12.16 3.78806 12.1595 3.78784 12.159 3.78759ZM10.4807 4.47988C9.2563 3.55829 7.20271 2.94597 4.7649 4.44473C3.27281 5.36207 2.25153 7.41257 2.60401 10.0466C2.95447 12.6657 4.68092 15.8621 8.71086 18.8517C10.3299 20.0528 10.9208 20.4614 12 20.4614C13.0792 20.4614 13.6701 20.0528 15.2891 18.8517C19.3191 15.8621 21.0455 12.6657 21.396 10.0466C21.7485 7.41257 20.7272 5.36207 19.2351 4.44473C16.7973 2.94597 14.7437 3.55829 13.5193 4.47988L13.4979 4.49599C13.2212 4.70426 12.9836 4.88316 12.7935 5.0079C12.6946 5.07274 12.5852 5.13877 12.4717 5.1902C12.3639 5.23901 12.1983 5.30007 12 5.30007C11.8017 5.30007 11.6361 5.23901 11.5283 5.1902C11.4148 5.13877 11.3054 5.07274 11.2065 5.00791C11.0164 4.88315 10.7787 4.70424 10.502 4.49596L10.4807 4.47988Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
